import { Component, EventEmitter, Output, ViewChild } from '@angular/core';
import {of, Subject, take, takeUntil} from 'rxjs';
import { BasePageComponent } from 'src/app/components/base-page/base-page.component';
import { reactivationTrx } from 'src/app/router-translation.labels';
import { LoginStatusService } from 'src/app/services/auth/login/login-status.service';
import { LoggedStatus } from 'src/app/services/auth/login/login.models';
import { UserCampaignService } from 'src/app/services/campaigns/campaign.service';
import { LicenceService } from 'src/app/services/utils/licence.service';
import { TranslationConfig } from 'src/app/utils/translate-config';
import { SwiperOptions } from 'swiper';
import { SwiperComponent } from 'swiper/angular';
import {switchMap} from "rxjs/operators";

@Component({
  selector: 'app-home-page-reactivation',
  templateUrl: './home-page-reactivation.component.html',
  styleUrls: ['./home-page-reactivation.component.scss']
})
export class HomePageReactivationComponent extends BasePageComponent {

  reactivationData: any;
  isLogin: boolean;
  public reactivationTrx = this.translationConfig.getTranslation(reactivationTrx)
  @Output() isVisible = new EventEmitter<boolean>();

  constructor(
    public userCampaignService: UserCampaignService,
    protected translationConfig: TranslationConfig,
    private loginStatus: LoginStatusService,
    public licenceService: LicenceService

  ) { super() }
  @ViewChild(SwiperComponent, { static: false }) componentRef?: SwiperComponent;
  config: SwiperOptions = {
    direction: 'horizontal',
    slideToClickedSlide: false,
    mousewheel: false,
    scrollbar: false,
    keyboard: true,
    freeMode: false,
    slidesPerView: 4,
    slidesPerGroup: 1,
    centerInsufficientSlides: false,
    centeredSlides: false,
    loop: false,
    spaceBetween: 10,
    pagination: false,
    observer: true,
    observeParents: true,
    parallax: true,
  };


  ngOnInit(): void {
    const unsubscribe = new Subject();
    this.loginStatus.getIfUserLogged().pipe(
      take(1),
      switchMap(resp => {
        this.isLogin = resp.isLogged === LoggedStatus.logged;
        if (this.isLogin) {
          return this.userCampaignService.getActiveCampaign();
        } else {
          return of(null);
        }
      }),
      takeUntil(unsubscribe)
    ).subscribe(resp => {
      if (resp) {
        if(!resp.campaign.name.toLowerCase().includes('xmas')){
          this.isVisible.emit(true);
          this.reactivationData = resp;
        }
        this.config.initialSlide = this.reactivationData?.currentRecursivePointer - 1;
      }
      else {
        this.isVisible.emit(false);
      }
    });
  }

  next() {
    this.componentRef.swiperRef.slideNext();
  }

  prev() {
    this.componentRef.swiperRef.slidePrev();
  }

}
